import React from 'react';
import { ConvertBytesToImage } from '../../Utils/Utils';
function ProductImages({ image }) {
  let imageUrl = '';
  if (image) {
    imageUrl = ConvertBytesToImage(image)
  }
  return (
    // code to show multiple images of a product
    // <div>
    //   {/* <h1>Product Name</h1> */}
    //   <Slider {...settings}>
    //     {images.map((image, index) => (
    //       <div key={index} className="product-details-big-image-slider-wrapper slider-for">
    //         <div className="single-image">
    //           <img src={image} alt={`Product Image ${index}`} />

    //         </div>
    //       </div>
    //     ))}
    //   </Slider>
    // </div>

    // Code to show  a single image

    <div className="product-details-big-image-slider-wrapper slider-for">
      <div className="single-image">
        <img src={imageUrl} alt="Product not found" loading="lazy" />
      </div>
    </div>
  );
}
export default ProductImages;
